import React from "react";
import { useTranslation } from "react-i18next";
import { InfoTip } from "@/components/InfoTip";

// Explanatory bubble shown under the Format select for the image-based formats.
export function FormatHelp({ format }) {
  const { t, i18n } = useTranslation();
  if (!["poeme", "metaphore"].includes(format) || !i18n.exists(`format_help.${format}`)) return null;
  const k = `format_help.${format}`;
  const lines = t(`${k}.lines`, { returnObjects: true });
  return (
    <div className="flex items-center gap-1.5 text-[12px] text-[#002FA7] -mt-2" data-testid={`format-help-${format}`}>
      <span>{t(`${k}.label`)}</span>
      <InfoTip
        testid={`format-help-${format}-info`}
        content={
          <div className="space-y-1">
            <div className="font-bold">{t(`${k}.title`)}</div>
            {lines.map((l) => <div key={l}>{l}</div>)}
            <div className="pt-1 opacity-80">{t(`${k}.foot`)}</div>
          </div>
        }
      />
    </div>
  );
}

export default FormatHelp;
